import SlimSelect from "slim-select"

function initSlimSelect() {
  document.querySelectorAll("select[data-slim-select]").forEach((select) => {
    if (select.dataset.slimSelectInitialized) return
    select.dataset.slimSelectInitialized = "true"

    const showSearch = select.dataset.showSearch !== "false"
    const submitOnChange = select.dataset.submitOnChange === "true"

    new SlimSelect({
      select,
      settings: {
        showSearch,
        searchPlaceholder: select.dataset.searchPlaceholder || "",
        searchText: select.dataset.noResultsText || "No Results",
        placeholderText: select.dataset.placeholderText || "",
      },
      events: submitOnChange
        ? {
            afterChange: () => {
              select.form?.dispatchEvent(new Event("submit", { bubbles: true }))
            },
          }
        : {},
    })
  })
}

window.initSlimSelect = initSlimSelect
document.addEventListener("DOMContentLoaded", initSlimSelect)
